import API from  '~/sdk/client'

interface AcceptInvitePayload {
  hash: string
}

export async function post({ hash }: AcceptInvitePayload): Promise<void> {
  return await API.post(`internal/v1/company/users/invite/${hash}/accept`)
}
